import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QUERY_KEYS } from '~constants'
import { getPurchaseHistory, writeToStorageCacheQuery } from '~services'
import { PurchaseHistoryResponse } from '~types/user'
import { useGetQueryState } from '~utils'

const { PURCHASE_HISTORY } = QUERY_KEYS

const purchaseHistoryQueryKey = [PURCHASE_HISTORY] as [string]

export function usePurchaseHistory(
  options?: UseQueryOptions<PurchaseHistoryResponse, unknown, PurchaseHistoryResponse>
) {
  const cachedData = useGetQueryState<PurchaseHistoryResponse>(purchaseHistoryQueryKey)

  const {
    isLoading: isFetchingPurchaseHistory,
    refetch: refetchPurchaseHistory,
    data,
  } = useQuery<PurchaseHistoryResponse>(purchaseHistoryQueryKey, getPurchaseHistory, {
    keepPreviousData: true,
    onSuccess: (data) => {
      writeToStorageCacheQuery(purchaseHistoryQueryKey, data)
    },
    ...options,
  })

  return {
    purchaseHistory: cachedData?.items || data?.items || [],
    total: cachedData?.total || data?.total || 0,
    isFetchingPurchaseHistory,
    refetchPurchaseHistory,
  }
}

usePurchaseHistory.queryKey = () => purchaseHistoryQueryKey


